/*
 * Location: assets/custom.js
 * What: Gelsome — ヘッダーメニュー（ドロワー）のページ内アンカーリンク対応。
 * Why: (1) Wonderはドロワーの開閉経路が2つある（base.jsのbodyクラス制御と
 *      page-header.jsのスティッキートリガー制御）。開いた経路と同じ経路で
 *      閉じないと、メニュー開状態が残りスクロールがロックされる。
 *      (2) JSONテンプレート上の標準セクションのIDは
 *      shopify-section-template--{id}__{key} 形式のため、末尾一致で解決する。
 * RELEVANT FILES: assets/base.js, assets/page-header.js, assets/gelsome.css, templates/index.json
 */
(function () {
  'use strict';

  function resolveAnchorTarget(name) {
    if (!name) return null;
    var el = document.getElementById(name);
    if (el) return el;
    var esc = window.CSS && CSS.escape ? CSS.escape(name) : name;
    return (
      document.querySelector('.shopify-section[id$="__' + esc + '"]') ||
      document.querySelector('.shopify-section[id$="-' + esc + '"]')
    );
  }

  function closeDrawerIfOpen() {
    var stickyTrigger = document.querySelector('.wt-header__sticky-menu-trigger--active');
    if (stickyTrigger) stickyTrigger.click();
    if (document.body.classList.contains('menu-open')) {
      var drawer = document.getElementById('wt-drawer-nav');
      var closeBtn = drawer && drawer.querySelector('.wt-drawer__close');
      if (closeBtn) closeBtn.click();
    }
  }

  function smoothScrollTo(target, hash) {
    if (window.history && window.history.pushState && hash) {
      window.history.pushState(null, '', hash);
    }
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('#wt-drawer-nav a[href*="#"], .wt-header a[href*="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;
    var url;
    try { url = new URL(href, window.location.href); } catch (err) { return; }
    if (!url.hash || url.pathname !== window.location.pathname) return;
    var target = resolveAnchorTarget(decodeURIComponent(url.hash.slice(1)));
    if (!target) return;
    e.preventDefault();
    closeDrawerIfOpen();
    window.setTimeout(function () { smoothScrollTo(target, url.hash); }, 250);
  });

  window.addEventListener('load', function () {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    var name = decodeURIComponent(hash.slice(1));
    if (document.getElementById(name)) return;
    var target = resolveAnchorTarget(name);
    if (!target) return;
    window.setTimeout(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  });
})();
